import { useEffect, useState } from "react";

// True while the element intersects the viewport (+ optional margin). Used to pause WebGL loops offscreen.
export const useInViewActive = (ref, rootMargin = "0px", initial = true) => {
  const [active, setActive] = useState(initial);
  useEffect(() => {
    const el = ref.current;
    if (!el) return undefined;
    const io = new IntersectionObserver(([e]) => setActive(e.isIntersecting), { threshold: 0, rootMargin });
    io.observe(el);
    return () => io.disconnect();
  }, [ref, rootMargin]);
  return active;
};
